import {
  Accordion,
  Box,
  Flex,
  LocationPinIcon,
  Typography,
} from '@iheartjane/reefer';
import truncate from 'lodash-es/truncate';

import { formatPhone } from '@jane/shared/util';

import styles from './MenuQuickCheckoutDrawer.module.css';

interface QuickCheckoutStoreDetailsProps {
  storeAddress: string;
  storePhone: string;
}

export const QuickCheckoutStoreDetails = ({
  storeAddress,
  storePhone,
}: QuickCheckoutStoreDetailsProps) => (
  <Box className={styles['checkoutAccordionItem']}>
    <Accordion.Item id="store-details">
      <Accordion.Heading>
        <Flex gap={16}>
          <div>
            <LocationPinIcon />
          </div>
          <Flex flexDirection="column">
            <Typography variant="body-semibold">Store details</Typography>
            <Accordion.Summary>
              <Typography>{truncate(storeAddress, { length: 40 })}</Typography>
            </Accordion.Summary>
          </Flex>
          <Flex ml="auto" alignItems="center" height="100%">
            <Accordion.Indicator iconSize="md" />
          </Flex>
        </Flex>
      </Accordion.Heading>
      <Accordion.Content>
        <Flex flexDirection="column" mx={40}>
          <Typography>{storeAddress}</Typography>
          <Typography>{formatPhone(storePhone)}</Typography>
        </Flex>
      </Accordion.Content>
    </Accordion.Item>
  </Box>
);
